export const SET_DOCUMENTS = 'documents/SET_DOCUMENTS';
